export default {
  bold: 'Fett',
  italic: 'Kursiv',
  underline: 'Unterstreichen',
  list: 'Nummerierte Liste',
  link: 'Link',
  codeblock: 'Codeblock',
};
